import script from "./WantedCsvImport.vue?vue&type=script&setup=true&lang=js"
export * from "./WantedCsvImport.vue?vue&type=script&setup=true&lang=js"

import "./WantedCsvImport.vue?vue&type=style&index=0&id=54e3f8e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e3f8e6"]])

export default __exports__